export default {
  methods: {
    /*
    * 树形二级请求数据处理
    * pid：父级id
    * type: 父级key
    * data: 二级数据
    * navItem: 导航对象数据
    * isLeaf是否是叶子，没有子级
    * pObj 父级所有元素
    */
    treeChildHandle(pid, type, data, navItem, isLeaf, pObj) {
      const treeList = data.reduce((preArr, item) => {
        item.key = item.id
        item.type = type
        item.id = item.name
        item.leaf = isLeaf || item.hasNoChild || false
        item.pid = pid
        // 父级元素名称
        if (pObj) item.pName = pObj.name
        if (item.name) preArr.push(item)
        return preArr
      }, [])
      // 如果pid不存在则，返回数据
      if (!pid) return treeList
      // 赋值给原数据
      const selectObj = navItem.infosList.find(item => item.key === type) || {} // 6
      const index = selectObj.children.findIndex(item => item.key === pid)
      if (index >= 0) {
        const obj = selectObj.children[index]
        obj.children = treeList
      }
      return navItem
    },
    // 联动字符串转数组
    strChangeArr(value, separator) {
      let arr = []
      if (value) {
        const splitArr = value.split(separator || '-')
        arr = splitArr.map(item => {
          item = item.replace(/(^\s*)|(\s*$)/g, '')
          return item
        })
      }
      return arr
    },
    // 页面初始化
    formInt(infoArr) {
      // 页面初始化
      // const [...formArr] = infoArr
      const formArr = JSON.parse(JSON.stringify(infoArr))
      return formArr.map(item => {
        item.isEdit = false
        item.isAllowEdit = true
        item.isFinishCopy = false
        if (item.infosList && item.infosList.length) {
          item.infosList.forEach(elem => {
            !elem.value && (elem.value = '')
            elem.inpVal = elem.value || ''
            elem.isReg = true // 默认所有字段都符合规则
          })
        }
        return item
      })
    },
    // 页面加载请求完成之后，数据初始化处理
    ajaxFinishInt(data, $formArr) {
      const formArr = JSON.parse(JSON.stringify($formArr))
      data.forEach(res => {
        formArr.forEach(item => {
          item.infosList = item.infosList || []
          const filterObj = item.infosList.find(elem => elem.key === res.id)
          // 判断下拉子级
          if (filterObj) {
            filterObj.children = res.data
            // 基础接口返回中文，则需要转化为id
            if (res.isValueTxt && filterObj.value) {
              let val = ''
              // 多选时返回数据格式是以逗号，隔开的数组格式
              if (filterObj.isMoreChoose && filterObj.type === 'select') {
                const initVal = filterObj.value.split(',')
                val = initVal.reduce((preArr, itemVal) => {
                  const findObj = filterObj.children.find(elem => elem.name === itemVal) || {}
                  if (findObj) preArr.push(findObj.id)
                  return preArr
                }, [])
              } else {
                // 单选初始化
                const findItem = filterObj.children.find(elem => elem.name === this.baseInfoObj[res.id])
                if (findItem) val = findItem.id || ''
                // this.baseInfoObj[res.id] = val
              }
              filterObj.value = val
              filterObj.inpVal = filterObj.value
            }
          }
        })
      })
      return formArr
    },
    // 所有筛选条件返回数据处理
    getDataHandle(data, key, value, isHasChild) {
      const result = data.map(item => {
        const obj = {
          id: item[key || 'id'] || '',
          name: item[value || 'name'] || '',
          isShow: item.isShow || 0,
          hasNoChild: isHasChild || item.hasNoChild
        }
        if (item.level) obj.level = item.level
        return obj
      })
      return result
    },
    // 初始化完成，联动处理
    getPickInt(formArr, key) {
      let classCode = ''
      formArr.forEach(item => {
        const filterObj = item.infosList.find(elem => elem.key === key)
        if (filterObj) classCode = filterObj.inpVal
      })
      return classCode
    },
    /*
    * 联动改变之后二级数据处理
    * result 获取到该筛选的所有集合
    * key 该筛选条件的key值
    * initValue 初始化值
    * isTxt 是否是中文文字转为id
    * flag：操作识别，cancle --- 取消保存，save --- 保存
    */
    selectChangeHandle(result, key, initValue, isTxt, flag, cb) {
      let $index = 0
      let $obj = {}
      let currentFilterObj = {}
      this.formArr.forEach((item, index) => {
        const filterObj = item.infosList.find(elem => elem.key === key)
        if (filterObj) {
          if (initValue) {
            const findItem = result.find(elem => initValue === (isTxt ? elem.name : elem.id)) || {}
            filterObj.value = findItem.id || initValue || ''
          }
          filterObj.inpVal = (initValue || flag === 'cancle') ? filterObj.value : ''
          filterObj.children = result
          $index = index
          $obj = item
          currentFilterObj = filterObj
        }
      })
      this.$set(this.formArr, $index, $obj)
      // 如果还存在二级，则继续请求
      if (currentFilterObj && currentFilterObj.relatedKey) {
        if (flag === 'init' && cb) {
          cb()
        } else {
          this.componentChange(currentFilterObj.inpVal, currentFilterObj, flag, $index)
        }
      }
    },
    // 通过key获取value, flag --- true: 则表示其他地方传值识别
    handleTxtByKey(item, value, flag) {
      if (item.type === 'select' && item.children) {
        if (typeof value === 'object') {
          value = value.reduce((str, itemVal) => {
            const findObj = item.children.find(elem => elem.id + '' === itemVal + '') || {}
            if (findObj.name) str += findObj.name + ','
            return str
          }, '')
          if (value) value = value.substr(0, value.length - 1)
        } else {
          const findObj = item.children.find(elem => elem.id + '' === value + '') || {}
          value = findObj.name || ''
        }
      }
      return value || ''
    },
    // 模块编辑
    formItemEdit(pItem, index) {
      // 判断当前是否存在编辑模块正在编辑未保存
      if (!pItem.isAllowEdit) {
        const findEditModel = this.formArr.find(item => item.isEdit)
        this.$message({
          type: 'warning',
          message: findEditModel.title + '正在编辑中，请先保存或者取消编辑！'
        })
        return
      }
      // 禁止其他模块编辑，改变模块isAllowEdit状态
      this.formArr.forEach((item, formIndex) => {
        item.isAllowEdit = formIndex === index
      })
      pItem.isEdit = true
      if (pItem.type === 'table' && this.tableData) {
        // 内存缓存table数据
        this.tableCacheData = JSON.parse(JSON.stringify(this.tableData))
      }
    },
    // 循环查找目标对象
    targeFind(relatedKey) {
      let targetItem = {}
      this.formArr.forEach((formItem, index) => {
        formItem.infosList.forEach(elem => {
          if (elem.key === relatedKey) targetItem = elem
        })
      })
      return targetItem
    },
    // 取消
    cancelBtn(item, index) {
      this.formArr.forEach((formItem, formIndex) => {
        formItem.isAllowEdit = true
      })
      // 取消还原之前数据
      if (item.type === 'table') {
        this.tableData = this.tableCacheData
        this.$refs.manageEdit.copyTable(item)
      } else {
        item.infosList.forEach(elem => {
          elem.inpVal = elem.value || ''
          if (item.relatedKey) this.componentChange(elem.value, elem, 'cancle', index)
        })
      }
      item.isEdit = false
      this.$set(this.formArr, item, index)
    },
    // 保存按钮，获取参数并且判断用户所填写的数据是否符合规则
    saveParam(item, index) {
      // 判断是否有字段被修改，如果有被修改，则请求接口保存，如果没有则直接改变编辑状态
      let isInsert = false
      // 获取所有参数
      const param = item.infosList.reduce((obj, elem) => {
        const key = elem.key
        // 两种情况可修改信息：定义不可修改并且没有值的；允许修改的
        // if (!elem.noInsert || (elem.noInsert && (!elem.value || !elem.value.length))) obj[key] = elem.inpVal || ''
        obj[key] = (elem.inpVal || '') + (elem.inpVal && elem.isParamAddUnit ? elem.unit || '' : '')
        // 判断传参是否需要转为中文
        if (elem.isValueTxt) {
          obj[key] = this.handleTxtByKey(elem, elem.inpVal, true)
        }
        // 判断关联值如果不在改模块内,则需要处理
        if (elem.relatedKey) {
          obj = Object.assign(obj, this.relationSaveBeforeHandle(item, elem))
        }
        // 判断该字符是否被修改过
        if (this.baseInfoObj[key] !== obj[key] && !elem.noInsert) {
          isInsert = true
        }
        return obj
      }, {})
      console.log(isInsert)
      // 用户没有修改过，则直接前端改变编辑状态
      if (!isInsert) {
        item.infosList.forEach(elem => {
          elem.value = elem.inpVal || ''
        })
        item.isEdit = false
        this.$set(this.formArr, item, index)
        // 保存成功之后所有模块方可编辑
        this.formArr.forEach((formItem, formIndex) => {
          formItem.isAllowEdit = true
        })
        return
      }
      return {
        isInsert: isInsert,
        param: param
      }
    },
    // 保存前关联参数处理
    relationSaveBeforeHandle(currentItem, currentElem, obj = {}) {
      const relatedKeys = currentElem.relatedKey.split(',') || []
      relatedKeys.forEach(relatedKey => {
        // 判断当前关联的对象是否在同一模块
        let targetItem = currentItem.infosList.find(item => item.key === relatedKey)
        // 不在同一模块需要重新处理
        if (!targetItem) {
          targetItem = this.targeFind(relatedKey)
          obj[relatedKey] = targetItem.inpVal || ''
          // 判断传参是否需要转为中文
          if (targetItem.isValueTxt) {
            obj[relatedKey] = this.handleTxtByKey(targetItem, targetItem.inpVal, true)
          }
          // 是否还有关联对象
          if (targetItem.relatedKey) {
            obj = this.relationSaveBeforeHandle(currentItem, targetItem, obj)
          }
        }
      })
      return obj
    },
    // 表格参数教研
    saveTableParam(pItem, index, tableData) {
      // 验证所有字段是否符合规则
      let regTxt = ''
      const saveList = tableData.map(item => {
        const obj = {}
        pItem.infosList.forEach(infoItem => {
          const key = infoItem.key
          obj[key] = item[key] || ''
          // 字段是否存在正则验证以及是否符合规则
          if (!item['is-' + key + '-Reg']) {
            regTxt = infoItem.placeholder || (infoItem.label + '格式不正确！')
          }
        })
        return obj
      })
      // 判断验证提示
      if (regTxt) {
        this.$message({
          type: 'warning',
          message: regTxt
        })
        return
      }
      return saveList
    },
    // 保存成功之后回调
    saveSuccessfn(item, index, param) {
      this.$message({
        type: 'success',
        message: '保存成功！'
      })
      if (!item) return
      // 保存成功之后所有模块方可编辑
      this.formArr.forEach((formItem, formIndex) => {
        formItem.isAllowEdit = true
      })
      // 更新同步页面展示
      item.infosList.forEach(elem => {
        // 更新页面值
        this.saveValueHandle(param, item, elem)
      })
      item.isEdit = false
      this.$set(this.formArr, item, index)
    },
    // 值保存
    saveValueHandle(param, item, elem) {
      elem.value = elem.inpVal || ''
      // 更新页面值
      const key = elem.key
      let value = elem.value
      if (elem.isValueTxt) value = this.$refs.manageEdit.handleTxtByKey(key, param[key], true)
      this.baseInfoObj[key] = value
      // 保存后关联参数保存处理
      if (elem.relatedKey) this.relationSaveAfterHandle(param, item, elem)
    },
    // 保存前关联参数处理
    relationSaveAfterHandle(param, currentItem, currentElem) {
      const relatedKeys = currentElem.relatedKey.split(',') || []
      relatedKeys.forEach(relatedKey => {
        // 判断当前关联的对象是否在同一模块
        let targetItem = currentItem.infosList.find(item => item.key === relatedKey)
        // 不在同一模块需要重新处理
        if (!targetItem) {
          targetItem = this.targeFind(relatedKey) || {}
          // 更新值
          this.saveValueHandle(param, currentItem, targetItem)
        }
      })
    }
  }
}
